import styled from 'styled-components';
import { IProduct } from '../../../../interfaces/Product.interfaces';
import { ProductHorizontalListSummaryViewGroup } from './ProductHorizontalListSummaryViewGroup';

interface ProductHorizontalListSummaryViewGroupWrapperProps {
  products: IProduct[];
  category: 'pluva' | 'partner' | 'open-market';
  pageType: 'home' | 'pdp' | 'odp';
  currentProductForMarketAmpliEvent?: Pick<IProduct, 'category' | 'code'>;
  title: string;
}

export const ProductHorizontalListSummaryViewGroupWrapper = ({
  products,
  category,
  pageType,
  currentProductForMarketAmpliEvent,
  title,
}: ProductHorizontalListSummaryViewGroupWrapperProps) => {
  return (
    <Container pageType={pageType}>
      <ContentTitle>{title}</ContentTitle>

      <ProductHorizontalListSummaryViewGroup
        products={products}
        category={category}
        pageType={pageType}
        currentProductForMarketAmpliEvent={currentProductForMarketAmpliEvent}
      />
    </Container>
  );
};

const Container = styled.div<{ pageType: 'home' | 'pdp' | 'odp' }>`
  width: 100%;

  ${(props) => props.pageType === 'home' && 'padding: 0px 16px 32px 16px;'}
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;

  gap: 16px;
`;

const ContentHeader = styled.div`
  width: 100%;

  display: flex;
  justify-content: space-between;
  align-items: center;

  cursor: pointer;
`;

const ContentTitle = styled.h3`
  width: 100%;

  color: var(--Light-Scheme-Monochrome-black, #232429);

  /* System/XX-Large/xxl-bold */
  font-family: Pretendard;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 85%; /* 17px */
`;
